import React from "react";
import "../../View/Blog/Blog.css";

function BlogComment({img, nm, dt, mnth, time, amPm, year}) {
  return (
    <div className="mdCmntMainDiv">
      <figure className="cmntImgFig">
        <img src={img} alt="..." />
      </figure>
      <div className="mdAllTextsDiv">
        <p className="mdNameText">{nm}</p>
        <p className="mdDateText"><span>{mnth}</span> <span>{dt}</span>, <span>{year}</span> at <span>{time}</span><span>{amPm}</span></p>
        <p className="mdParaText">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat Lorem ipsum dolor sit amet,
          consectetur adipiscing elit.
        </p>
        <button className="mdReplyBtn">Reply</button>
      </div>
    </div>
  );
}

export default BlogComment;
